import { render, staticRenderFns } from "./EmbedManajemenToko.vue?vue&type=template&id=2ed7a128&scoped=true&"
import script from "./EmbedManajemenToko.vue?vue&type=script&lang=js&"
export * from "./EmbedManajemenToko.vue?vue&type=script&lang=js&"
import style0 from "./EmbedManajemenToko.vue?vue&type=style&index=0&id=2ed7a128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed7a128",
  null
  
)

export default component.exports